import {
  Box,
  Button,
  Flex,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getHistoryAPI } from "../../Redux/App/app.actions";
import { useDispatch, useSelector } from "react-redux";
import { FiDownloadCloud } from "react-icons/fi";
import JSZip from "jszip";
import saveAs from "file-saver";
import { formatDate } from "../utils/utils";
import { DownloadIcon } from "@chakra-ui/icons";
import { downloadBurdenMixApi } from "./downloadBurdenMixService";

export const handleDownload = async (id) => {
  console.log("payload", id);
  try {
    const response = await downloadBurdenMixApi(id);
    console.log(response.data);
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `compiled-burdenmix-${new Date().toISOString()}.xlsx`);
  } catch (error) {
    console.log(error);
  }

  // return;
  // function downloadZip(outputArray) {
  //   // console.log(inputArray, outputArray);
  //   const zip = new JSZip();

  //   // Create input folder and add input CSV files
  //   // const inputFolder = zip.folder("input");
  //   // inputArray.forEach(({ name, arr, columns }) => {
  //   //   const inputCsv = arrayToCsv(arr, columns);
  //   //   inputFolder.file(`${name}.csv`, inputCsv);
  //   // });

  //   // Create output folder and add output CSV files
  //   const outputFolder = zip.folder("output");
  //   outputArray.forEach(({ name, arr, columns }) => {
  //     if (name !== undefined && arr !== undefined) {
  //       const outputCsv = arrayToCsv(arr, columns);
  //       outputFolder.file(`${name}.csv`, outputCsv);
  //     }
  //   });

  //   // Generate zip file and download
  //   zip.generateAsync({ type: "blob" }).then(function (content) {
  //     saveAs(
  //       content,
  //       `${formatDate(payload.date).split("/")[0]}_imfa_burden_mix.zip`
  //     );
  //   });
  // }

  // function arrayToCsv(arr, columns = Object.keys(arr[0])) {
  //   const csvArray = [columns];
  //   arr.forEach((obj) => {
  //     const row = columns.map((header) => obj[header]);
  //     csvArray.push(row);
  //   });
  //   const csvContent = csvArray.map((row) => row.join(",")).join("\n");
  //   return csvContent;
  // }

  // let { input, output } = payload;
  // let { bounds, file } = input;
  // let { assumptions, constraints, controllers, weightage_factors } = bounds;

  // let {
  //   // best_individual_burden,
  //   // best_individual_calculated_burden,
  //   // best_individual_health_card_input,
  //   // best_individual_health_card_output,
  //   final_file: global_output,
  //   deviation,
  // } = output;
  // console.log("payload", { global_output });

  // // let inputArray = [
  // //   {
  // //     name: "Inventory",
  // //     arr: file,
  // //     columns: [
  // //       "Lot no.",
  // //       "Premises",
  // //       "Description",
  // //       "Avl.Qty.(MT)",
  // //       "P",
  // //       "SiO2",
  // //       "Cr2O3",
  // //       "FeO",
  // //       "CaO",
  // //       "MgO",
  // //       "Al2O3",
  // //       "Fe2O3",
  // //       "Additional Fe",
  // //       "S",
  // //       "FC",
  // //       "Analysis Status",
  // //       "ASH",
  // //     ],
  // //   },
  // //   {
  // //     name: "Assumptions",
  // //     arr: assumptions,
  // //     columns: ["name", "value"],
  // //   },
  // //   {
  // //     name: "Constraints",
  // //     arr: constraints,
  // //     columns: ["name", "value"],
  // //   },
  // //   {
  // //     name: "Controllers",
  // //     arr: controllers,
  // //     columns: ["name", "value", "category"],
  // //   },
  // //   {
  // //     name: "Weightage Factors",
  // //     arr: weightage_factors,
  // //     columns: ["name", "value"],
  // //   },
  // // ];

  // let outputArray = [
  //   // {
  //   //   name: "Best Individual Burden",
  //   //   arr: best_individual_burden,
  //   //   columns: [
  //   //     "Lot no.",
  //   //     "Description",
  //   //     "Type",
  //   //     "QTY(kgs)",
  //   //     "Qty used(Kgs)",
  //   //     "Cr",
  //   //     "Cr2O3",
  //   //     "Fe",
  //   //     "FeO",
  //   //     "Fe2O3",
  //   //     "MgO",
  //   //     "Si",
  //   //     "SiO2",
  //   //     "Al2O3",
  //   //     "CaO",
  //   //     "P",
  //   //     "S",
  //   //     "FC",
  //   //   ],
  //   // },
  //   // {
  //   //   name: "Best Individual Calculated Burden",
  //   //   arr: best_individual_calculated_burden,
  //   //   columns: [
  //   //     "index",
  //   //     "Cr",
  //   //     "Cr2O3",
  //   //     "Fe",
  //   //     "FeO",
  //   //     "Fe2O3",
  //   //     "MgO",
  //   //     "Si",
  //   //     "SiO2",
  //   //     "Al2O3",
  //   //     "CaO",
  //   //     "P",
  //   //     "S",
  //   //     "FC",
  //   //   ],
  //   // },
  //   // {
  //   //   name: "Best Individual Health Card Input",
  //   //   arr: best_individual_health_card_input,
  //   //   columns: ["Health_Indicator", "Value"],
  //   // },
  //   // {
  //   //   name: "Best Individual Health Card Output",
  //   //   arr: best_individual_health_card_output,
  //   //   columns: ["Health_Indicator", "Value"],
  //   // },
  //   {
  //     name: "Global output",
  //     arr: global_output,
  //   },
  //   // {
  //   //   name: "Deviation",
  //   //   arr: deviation,
  //   //   columns: [
  //   //     "Deviation",
  //   //     "Health_Indicator",
  //   //     "Maximium Recommended Value",
  //   //     "Minimium Recommended Value",
  //   //     "Value",
  //   //   ],
  //   // },
  // ];
  // // downloadZip(inputArray, outputArray);
  // downloadZip(outputArray);
};

const History = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, isError, data } = useSelector(
    (state) => state.app.history
  );

  useEffect(() => {
    if (!data || !data.length || data.length === 0) {
      dispatch(getHistoryAPI());
    }
  }, []);

  if (isLoading) {
    return (
      <Text fontSize="20px" fontWeight="600">
        Loading...
      </Text>
    );
  }
  if (data && data.length) {
    return (
      <Box w="100%" h="100%">
        <TableContainer w="100%" maxH={"80vh"} overflowY="auto">
          <Table variant="striped" colorScheme="facebook" size="sm">
            <Thead position="sticky" top="0" zIndex="sticky" bg="white">
              <Tr>
                <Th>Sr.No</Th>
                <Th>Id</Th>
                <Th>Date</Th>
                <Th>Created By</Th>
                <Th>Input Ore Material Sum</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody overflowX="hidden" overflowY="scroll">
              {data?.length > 0 &&
                data
                  .filter((el) => formatDate(el.date) !== "Invalid D / e")
                  .map((el, idx) => (
                    <Tr key={el._id}>
                      <Td>{idx + 1}</Td>
                      <Td>{el._id}</Td>
                      <Td>{formatDate(el.date)}</Td>
                      <Td textTransform="capitalize">
                        {el?.createdBy?.name || ""}
                      </Td>
                      <Td>{el?.input?.input_ore_material_sum || ""}</Td>
                      <Td>
                        {
                          <Button
                            m="5px"
                            colorScheme="blue"
                            onClick={() => handleDownload(el?._id)}
                          >
                            {/* <DownloadIcon />{" "} */}
                            <Text ml="5px">Download compiled burden</Text>
                          </Button>
                        }
                      </Td>
                    </Tr>
                  ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  return (
    <Box>
      <Box textAlign="center" py={10} px={6}>
        <Heading
          display="inline-block"
          as="h2"
          size="xl"
          bgGradient="linear(to-r, #15112e, #372c78)"
          backgroundClip="text"
        >
          No Past Burdens
        </Heading>
        <Text color={"gray.500"} mb={6}>
          Click on the below button to create a new Burden
        </Text>
        <Button
          onClick={() => navigate("/")}
          colorScheme="teal"
          _hover={{ bgGradient: "linear(to-r, #15112e, #372c78)" }}
          bgGradient="linear(to-r, #15112e, #372c78)"
          color="white"
          variant="solid"
        >
          create
        </Button>
      </Box>
    </Box>
  );
};

export default History;
